var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('DynamicList',{ref:"dynamicCardList",attrs:{"searchFormStructure":_vm.dataSearchFormStructure,"columns":_vm.dataColumns,"edit":_vm.dataEdit,"onRetrieve":_vm.onRetrieve,"root":"/report/commerce-tickets-2","searchArgs":_vm.searchArgs}},[_vm._t("default",[_c('b-button',{staticClass:"mb-3",attrs:{"variant":"light"},on:{"click":function($event){_vm.$refs.modalExport.open = true}}},[_vm._v("\n                "+_vm._s(_vm.Core.Definition.getDefinition("Exporter sous format ..."))+"\n            ")]),_c('ModalExport',{ref:"modalExport",attrs:{"root":"/report/commerce-tickets-2","formStructure":{
                            rows: [
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'exportFormat'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                 {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'exportTitle'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'firstname'
                                                }
                                            ]
                                        },
                                        {
                                            fields: [
                                                {
                                                    id: 'lastname'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'teamTitle'
                                                }
                                            ]
                                        },
                                        {
                                            fields: [
                                                {
                                                    id: 'participantCategoryTitle'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'tshirtSize'
                                                }
                                            ]
                                        },
                                        {
                                            fields: [
                                                {
                                                    id: 'tshirtCustomName'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    cols: [
                                       {
                                            fields: [
                                                {
                                                    id: 'seasonTitle'
                                                }
                                            ]
                                        },
                                        {
                                            fields: [
                                                {
                                                    id: 'ticketNumber'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'urgencyContact'
                                                }
                                            ]
                                        },
                                        {
                                            fields: [
                                                {
                                                    id: 'urgencyPhone'
                                                }
                                            ]
                                        }
                                    ]
                                },

                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'leagueTitle'
                                                }
                                            ]
                                        },
                                         {
                                            fields: [
                                                {
                                                    id: 'eventDate'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'address'
                                                }
                                            ]
                                        },
                                        {
                                            fields: [
                                                {
                                                    id: 'productTitle'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'code'
                                                }
                                            ]
                                        },
                                        {

                                        }
                                    ]
                                }

                            ],
                            fields: [
                                {
                                    id: 'exportFormat',
                                    type: 'select',
                                    options: _vm.Core.Export.formatOptions(),
                                    label: _vm.Core.Definition.getDefinition('Format'),
                                    value: null,
                                    onSelect: function() {}
                                },
                                {
                                    id: 'exportTitle',
                                    type: 'text',
                                    label: _vm.Core.Definition.getDefinition('Titre'),
                                    value: '',
                                    required: true
                                },

                                {
                                    id: 'firstname',
                                    type: 'checkbox',
                                    labelCols: 6,
                                    label: _vm.Core.Definition.getDefinition('Prénom'),
                                    value: true,
                                     export: 'firstname',
                                    onChange: function() {}
                                },
                                {
                                    id: 'lastname',
                                    type: 'checkbox',
                                    labelCols: 6,
                                    label: _vm.Core.Definition.getDefinition('Nom de famille'),
                                    value: true,
                                     export: 'lastname',
                                    onChange: function() {}
                                },

                                {
                                    id: 'tshirtSize',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Taille T-Shirt'),
                                    value: true,
                                    labelCols: 6,
                                     export: 'tshirtSize',
                                    onChange: function() {}
                                },
                                {
                                    id: 'tshirtCustomName',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Nom personnalisé'),
                                    value: true,
                                    labelCols: 6,
                                     export: 'tshirtCustomName',
                                    onChange: function() {}
                                },
                                {
                                    id: 'urgencyContact',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Contact d\'urgence'),
                                    value: true,
                                    labelCols: 6,
                                    export: 'urgencyContact',
                                    onChange: function() {}
                                },
                                {
                                    id: 'urgencyPhone',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Téléphone d\'urgence'),
                                    value: true,
                                    labelCols: 6,
                                    export: 'urgencyPhone',
                                    onChange: function() {}
                                },
                                {
                                    id: 'insuranceNumber',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Assurance maladie'),
                                    value: true,
                                    labelCols: 6,
                                    export: 'insuranceNumber',
                                    onChange: function() {}
                                },
                                {
                                    id: 'ticketNumber',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Numéro de billet'),
                                    value: true,
                                    labelCols: 6,
                                    export: 'ticketNumber',
                                    onChange: function() {}
                                },
                                {
                                    id: 'teamTitle',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Nom équipe'),
                                    value: true,
                                    labelCols: 6,
                                    export: 'teamTitle',
                                    onChange: function() {}
                                },
                                {
                                    id: 'participantCategoryTitle',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Nom catégorie'),
                                    value: true,
                                    labelCols: 6,
                                    export: 'participantCategoryTitle',
                                    onChange: function() {}
                                },
                                {
                                    id: 'leagueTitle',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Ligue'),
                                    value: true,
                                    labelCols: 6,
                                     export: 'leagueTitle',
                                    onChange: function() {}
                                },
                                {
                                    id: 'seasonTitle',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Saison'),
                                    value: true,
                                    labelCols: 6,
                                     export: 'seasonTitle',
                                    onChange: function() {}
                                },

                                {
                                    id: 'eventDate',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Date'),
                                    value: true,
                                    labelCols: 6,
                                     export: 'eventDate',
                                    onChange: function() {}
                                },
                                {
                                    id: 'address',
                                    type: 'checkbox',
                                    labelCols: 6,
                                    label: _vm.Core.Definition.getDefinition('Adresse'),
                                    value: true,
                                     export: 'address',
                                    onChange: function() {}
                                },
                                 {
                                    id: 'productTitle',
                                    type: 'checkbox',
                                    labelCols: 6,
                                    label: _vm.Core.Definition.getDefinition('Nom de produit'),
                                    value: true,
                                     export: 'productTitle',
                                    onChange: function() {}
                                },
                                {
                                    id: 'code',
                                    type: 'checkbox',
                                    labelCols: 6,
                                    label: _vm.Core.Definition.getDefinition('Code promo'),
                                    value: true,
                                     export: 'code',
                                    onChange: function() {}
                                } ]}},on:{"onSubmit":_vm.onExport}})],{"slot":"afterSearchForm"})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }